import { createAsyncThunk } from '@reduxjs/toolkit';
import * as userService from './skills-favorite-tab-api';

export const getUserFavoriteContent = createAsyncThunk(
    'user/favoriteContent',
    async (_, { rejectWithValue }) => {
        try {
            const response = await userService.getUserFavoriteContent();
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteFavoriteContent = createAsyncThunk(
    'user/deleteFavoriteContent',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await userService.deleteFavoriteContent(id);
            return { data: response.data };
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
